module.exports = __webpack_public_path__ + "img/postits.f154c223.gif";